module.exports = __webpack_public_path__ + "img/zoomed-NIST-withwords.90907c54.png";